import { backgroundTransitionOnClick, flex, pointer, singleTextEllipsis } from '@byecode/ui'
import type { DataSourceAbstract, RecordPoint } from '@lighthouse/core'
import { ScrollArea } from '@mantine/core'
import cls from 'classnames'
import * as React from 'react'
import styled from 'styled-components'

import { FieldListItem } from './FieldListItem'

interface FieldListProps {
    value: string[]
    recordPoints: RecordPoint[]
    tableWidth?: number
    tableHeight?: number
    dataSource?: DataSourceAbstract | null
    isDriver?: boolean
    style?: React.CSSProperties
    onChange: (val: string) => void
    onScrollPositionChange?: (position: { x: number; y: number }) => void
}

const SCxText = styled.span<{ color?: string }>`
    font-size: var(--font-size-normal);
    color: ${({ color }) => color ?? 'var(--color-black)'};
    line-height: 16px;
    ${pointer}
    ${singleTextEllipsis}
`

const SCxSelectItem = styled.div`
    width: 100%;
    padding: 12px 16px;
    ${flex}
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    /* height: 38px;
    line-height: 38px; */
    ${backgroundTransitionOnClick}
    font-size: var(--font-size-normal);
    &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
        ${SCxText} {
            color: var(--color-gray-400);
        }
    }
`

const RelatedRecorderContent = styled(ScrollArea)<{ height?: number }>`
    position: relative;
    overflow: visible;
    width: 100%;
    display: flex;
    justify-content: stretch;
    max-height: 100%;

    & .mantine-ScrollArea-viewport {
        height: auto;

        max-height: ${({ height }) => (height ? `${height}px` : '100%')};
        > * {
            display: block !important;
            max-width: 100%;
        }
    }

    &.driver {
        ${SCxSelectItem}:not(:first-child) {
            border-top: 1px solid var(--color-gray-200);
        }
    }
`

const FieldList = React.forwardRef<HTMLDivElement, FieldListProps>(
    ({ recordPoints, value, tableHeight, dataSource, isDriver, style, onChange, onScrollPositionChange }, ref) => {
        if (!dataSource) {
            return null
        }
        return (
            <div style={{ flex: 1, overflow: 'hidden' }}>
                <RelatedRecorderContent
                    ref={ref}
                    height={tableHeight}
                    style={style}
                    className={cls({ driver: isDriver, test: true })}
                    onScrollPositionChange={onScrollPositionChange}
                >
                    {recordPoints?.map(recordPoint => (
                        <FieldListItem
                            key={recordPoint.id}
                            recordId={recordPoint.id}
                            dataSource={dataSource}
                            value={value}
                            disabled={recordPoint.disabled}
                            onChange={onChange}
                        />
                    ))}
                </RelatedRecorderContent>
            </div>
        )
    }
)

export default FieldList
